import { useDispatch } from "react-redux"
import { saveToServer } from "../store/features/app/appActions"
import { useCallback } from "react"
export const useDispatchAndSave = () => {
    const dispatch = useDispatch()
    return useCallback((action) => {
        dispatch(action)
        dispatch(saveToServer())
    },[dispatch])
}
